export const LANGS = [
  { id: 'tr', label: 'TR' },
  { id: 'en', label: 'EN' },
];

export const translations = {
  tr: {
    // ---------- common ----------
    'common.back': 'Geri',
    'common.next': 'Devam Et',
    'common.cancel': 'Vazgeç',
    'common.delete': 'Sil',
    'common.download': 'İndir',
    'common.loading': 'Yükleniyor...',
    'common.locale': 'tr-TR',
    'common.pieces': '{count} adet',
    'common.none': 'Yok',
    'common.seconds': 'sn',
    'common.copied': 'Kopyalandı',
    'common.copyManually': 'Elle kopyala: {text}',
    'common.irreversible': 'Bu işlem geri alınamaz.',
    'common.langLabel': 'Dil',

    // ---------- nav ----------
    'nav.studio': 'Stüdyo',
    'nav.gallery': 'Galeri',
    'nav.account': 'Hesabım',
    'nav.admin': 'Admin',
    'nav.adminPanel': 'Admin Panel',
    'nav.accountCredits': 'Hesabım & Haklar',
    'nav.logout': 'Çıkış Yap',
    'nav.creditsShort': 'hak',

    // ---------- landing ----------
    'landing.goStudio': 'Stüdyoya Git',
    'landing.login': 'Giriş Yap',
    'landing.tryNow': 'Hemen Dene!',
    'landing.heroLine1': 'Bundan sonra daha fazla',
    'landing.heroLine2': 'izleneceksiniz...',
    'landing.heroDesc':
      'Pablo Picasso\u2019nun \u201Ciyi sanatçılar\u201D cümlesinden esinlenerek, sadece referansını ver ve kendi fotoğrafınla kapak fotoğrafı üretimini yap.',
    'landing.freeBadge': 'Beleşe {count} kapak hakkı dağıtıyoruz',
    'landing.card1Title': 'Yatay Video',
    'landing.card1Desc': 'Klasik YouTube videoları için geniş ekran kapak.',
    'landing.card2Title': 'YT Shorts',
    'landing.card2Desc': 'Dikey Shorts videoları için tam ekran kapak.',
    'landing.footer': 'Spunkram Thumbnailer - Yapay zeka destekli kapak fotoğrafı stüdyosu',
    'how.eyebrow': 'NASIL ÇALIŞIR',
    'how.title': 'Üç adımda ham görselden tıklanan kapağa',
    'how.subtitle':
      'İlham aldığın kapağı ya da kendi ham fotoğrafını ver, ne değişmesini istediğini yaz. '
      + 'Gerisini biz hallediyoruz - çıktı tam ölçüde, indirmeye hazır geliyor.',
    'how.s1Title': 'Referansı ver',
    'how.s1Desc':
      'İlham aldığın kapağın YouTube linkini yapıştır ya da görseli yükle.',
    'how.s2Title': 'Ne değişsin, söyle',
    'how.s2Desc':
      'Yazıyı, arka planı, ışığı tek cümleyle anlat. Aynı kalmasını istediklerini de yazabilirsin.',
    'how.s3Title': 'Kapağın hazır',
    'how.s3Desc':
      'Yatay 1920x1080 veya dikey 1080x1920, 2 MB altında JPG olarak saniyeler içinde indir.',
    'how.beforeLabel': 'ÖNCE',
    'how.afterLabel': 'SONRA',
    'how.editsLabel': 'İSTEKLERİN',
    'how.edit1': 'yüzümü kullan ve yazıyı değiştir',
    'how.beforeAlt': 'Referans olarak verilen kapak',
    'how.afterAlt': 'Spunkram ile üretilen kapak',
    'how.note': 'Yukarıdaki örnek, Spunkram ile üretilmiş gerçek bir kapak akışıdır.',

    // ---------- auth ----------
    'auth.loginTitle': 'Giriş Yap',
    'auth.loginSubtitle': 'Kapak üretmeye kaldığın yerden devam et.',
    'auth.email': 'E-posta',
    'auth.emailPlaceholder': 'ornek@mail.com',
    'auth.password': 'Şifre',
    'auth.passwordPlaceholder': '********',
    'auth.noAccount': 'Hesabın yok mu?',
    'auth.registerLink': 'Kayıt ol',
    'auth.welcome': 'Hoş geldin!',
    'auth.loginFailed': 'Giriş yapılamadı',
    'auth.registerTitle': 'Kayıt Ol',
    'auth.registerSubtitle': 'Hemen başla - hoş geldin hediyesi olarak {count} kapak fotoğrafı hesabında.',
    'auth.name': 'Ad Soyad',
    'auth.namePlaceholder': 'Adın',
    'auth.passwordMin': 'En az 6 karakter',
    'auth.passwordTooShort': 'Şifre en az 6 karakter olmalı',
    'auth.createAccount': 'Hesap Oluştur',
    'auth.registerSuccess': 'Hesabın hazır - {count} kapak fotoğrafı hediye edildi!',
    'auth.registerFailed': 'Kayıt oluşturulamadı',
    'auth.haveAccount': 'Zaten hesabın var mı?',
    'auth.loginLink': 'Giriş yap',
    'auth.googleContinue': 'Google ile devam et',
    'auth.googleSigningIn': 'Google hesabınla giriş yapılıyor...',
    'auth.googleFailed': 'Google ile giriş yapılamadı',
    'auth.or': 'veya',

    // ---------- studio ----------
    'studio.title': 'Stüdyo',
    'studio.subtitle': 'Dört adımda kapak fotoğrafını üret.',
    'studio.selectedFormat': 'Seçili format',
    'studio.balance': 'Bakiye: {count} kapak hakkı',
    'studio.step1Title': 'Format & Referans',
    'studio.step1Hint': 'YouTube / Shorts',
    'studio.step2Title': 'Fotoğraf Seçimi',
    'studio.step2Hint': 'Kendi fotoğrafın',
    'studio.step3Title': 'Yazılar & İstek',
    'studio.step3Hint': 'Ne değişecek?',
    'studio.step4Title': 'Özet ve Onay',
    'studio.step4Hint': 'Üret ve indir',
    'studio.fidelityExact': 'Aşırı Benzer',
    'studio.fidelityCreative': 'Yaratıcı',
    'studio.fidelityExactDesc': 'Değişmesini istediğin yerler dışında her şey birebir aynı kalır',
    'studio.fidelityCreativeDesc':
      'Renk, ikon gibi öğeleri yenileyip referansın mantığıyla daha farklı üretir',
    'studio.coverReady': 'Kapak hazır!',
    'studio.genFailed': 'Üretim başarısız: {error}',
    'studio.unknownError': 'bilinmeyen hata',
    'studio.statusFetchFailed': 'Üretim durumu alınamadı',
    'studio.needSomething': 'Referans görsel yoksa en az bir yazı veya özel istek yazmalısın',
    'studio.startFailed': 'Üretim başlatılamadı',
    'studio.downloadStarted': 'İndirme başladı',
    'studio.downloadFailed': 'Dosya indirilemedi',

    // summary rows
    'studio.sum.coverType': 'Kapak türü',
    'studio.sum.output': 'Çıktı',
    'studio.sum.reference': 'Referans',
    'studio.sum.photo': 'Fotoğraf',
    'studio.sum.extras': 'Ek görsel',
    'studio.sum.texts': 'Yazılar',
    'studio.sum.fidelity': 'Sadakat',
    'studio.sum.cost': 'Maliyet',
    'studio.sum.costValue': '1 kapak fotoğrafı hakkı',
    'studio.sum.ytShorts': 'YT Shorts (9:16)',
    'studio.sum.youtube': 'YouTube (16:9)',
    'studio.sum.refYoutube': 'YouTube kapağı',
    'studio.sum.refUpload': 'Yüklenen görsel',
    'studio.sum.photoSelected': 'Seçildi',
    'studio.sum.photoUnused': 'Kullanılmıyor',
    'studio.sum.textsUnchanged': 'Değişmeyecek',

    // step 1
    'step1.coverQuestion': 'Ne kapağı olacak?',
    'step1.coverDesc':
      'Çıktı formatını belirler. Yatay bir referans versen bile Shorts seçersen dikeye uygun şekilde yeniden kurgulanır.',
    'step1.youtubeHint': '16:9 yatay - 1920x1080',
    'step1.shortsHint': '9:16 dikey - 1080x1920',
    'step1.refTitle': 'Referans Görsel',
    'step1.refDesc':
      'İlham alacağımız kapağı ver. Görsel yükle/yapıştır ya da YouTube linkinden otomatik çek.',
    'step1.refUploaded': 'Referans görsel yüklendi.',
    'step1.refUploadedToast': 'Referans görsel yüklendi',
    'step1.uploadFailed': 'Görsel yüklenemedi',
    'step1.pasteFirst': 'Önce bir YouTube linki yapıştır',
    'step1.fetched': 'Kapak görseli çekildi',
    'step1.fetchFailed': 'Kapak görseli çekilemedi',
    'step1.orYoutube': 'VEYA YOUTUBE LİNKİ',
    'step1.fetchCover': 'Kapağı Çek',
    'step1.youtubeNote':
      'Sadece yatay YouTube videolarının linki desteklenir. Shorts linki verirsen uyarı alırsın - dikey kapak için yukarıdan \u201CYT Shorts\u201Du seç, referans olarak yatay bir kapak ver.',
    'step1.dropTitle': 'Referans görseli sürükle, tıkla veya Ctrl+V ile yapıştır',
    'step1.sourceYoutube': 'YouTube',
    'step1.sourceUpload': 'Yüklenen görsel',

    // step 2
    'step2.title': 'Fotoğraf Seçimi',
    'step2.desc': 'Kendi fotoğrafını kapağa eklemek istersen aşağıdaki seçeneği aç ve bir fotoğraf seç.',
    'step2.switchLabel': 'Fotoğraf kullanmak istiyor musun?',
    'step2.emptyTitle': 'Henüz fotoğraf yüklemedin',
    'step2.emptyDesc1': 'Buradan hemen yükleyebilir veya',
    'step2.emptyLink': 'Hesabım > Fotoğraflarım',
    'step2.emptyDesc2': 'bölümünü kullanabilirsin.',
    'step2.uploadTitle': 'Yeni fotoğraf yükle',
    'step2.uploadHint': 'Yüklediğin fotoğraflar Hesabım bölümünde saklanır',
    'step2.skip': 'Fotoğraf kullanmayacaksın - bu adımı atlayıp devam edebilirsin.',
    'step2.photosAdded': 'Fotoğraf(lar) eklendi',
    'step2.photoUploadFailed': 'Fotoğraf yüklenemedi',

    // step 3
    'step3.textsTitle': 'Yazılar',
    'step3.textsDesc':
      'Sadece kelime yazarsan, referanstaki yazının yerine birebir aynı stille o kelime yazılır. \u201Cinsane yerine müthiş yazsın\u201D gibi bir talimat da yazabilirsin.',
    'step3.textsPlaceholder': 'Örn: MÜTHİŞ   veya:  insane yerine müthiş yazsın',
    'step3.promptTitle': 'Özel İstek',
    'step3.promptDesc':
      'Kapakta başka ne değişsin veya ne aynen kalsın? Ek görselleri @1, @2 ile konumlandır.',
    'step3.promptPlaceholder':
      'Örn: Arka planı kırmızı-siyah yap, yüzü netleştir, poz aynen kalsın. @1 görseli sağda olsun.',
    'step3.sug1': 'Arka planı kırmızı-siyah yap, kontrastı artır',
    'step3.sug2': 'Yüz ifadesini daha şaşkın yap',
    'step3.sug3': 'Daha sinematik ışık ve gölge ekle',
    'step3.sug4': 'Yüz ve poz aynen kalsın',
    'step3.extrasTitle': 'Ek Görseller',
    'step3.extrasMax': 'En fazla 4 ek görsel ekleyebilirsin',
    'step3.extrasAdded': '{count} ek görsel eklendi',
    'step3.extrasFailed': 'Ek görsel yüklenemedi',
    'step3.extrasDropTitle': 'Ek görsel ekle (@1, @2 ...)',
    'step3.extrasDropHint': 'Ürün, logo, kişi veya obje görselleri - en fazla 4',
    'step3.addToPrompt': 'Özel isteğe ekle',
    'step3.fidelityTitle': 'Referansa Sadakat',
    'step3.tip':
      'İpucu: Değişmesini istemediğin şeyleri de yaz. Örnek: \u201CYüz ve poz aynen kalsın, sadece arka planı değiştir.\u201D',

    // step 4
    'step4.title': 'Özet ve Onay',
    'step4.desc':
      'Çıktı {size} piksel, 2 MB altında JPG olarak teslim edilir. Bu üretim 1 kapak fotoğrafı hakkı harcar.',
    'step4.summaryTitle': 'Üretim Özeti',
    'step4.noCreditsTitle': 'Kapak fotoğrafı hakkın kalmadı',
    'step4.noCreditsLink': 'Kapak Fotoğrafı Hakkı Satın Al',
    'step4.noCreditsDesc': 'bölümünden yeni hak ekleyebilirsin.',
    'step4.generating': 'Üretiliyor...',
    'step4.generate': 'Kapağı Üret',

    // preview panel
    'preview.title': 'Önizleme',
    'preview.status1': 'Referans analiz ediliyor...',
    'preview.status2': 'Kompozisyon hazırlanıyor...',
    'preview.status3': 'Detaylar işleniyor...',
    'preview.status4': 'Renk ve kontrast ayarlanıyor...',
    'preview.status5': 'Son rötuşlar yapılıyor...',
    'preview.resultAlt': 'Üretilen kapak',
    'preview.failedTitle': 'Üretim başarısız',
    'preview.refunded': 'Kapak hakkın iade edildi.',
    'preview.refAlt': 'Referans önizleme',
    'preview.emptyHint': 'Referans eklediğin an burada önizleme görünecek',
    'preview.dontClose': 'Üretim sürüyor - sekmeyi kapatma.',
    'preview.downloadPng': 'PNG İndir',
    'preview.variation': 'Varyasyon',
    'preview.newCover': 'Yeni Kapak',

    // ---------- gallery ----------
    'gallery.title': 'Galeri',
    'gallery.subtitle': 'Ürettiğin tüm kapaklar burada.',
    'gallery.filterAll': 'Tümü',
    'gallery.loadFailed': 'Galeri yüklenemedi',
    'gallery.deleted': 'Silindi',
    'gallery.deleteFailed': 'Silinemedi',
    'gallery.downloadFailed': 'İndirilemedi',
    'gallery.emptyTitle': 'Henüz üretim yok',
    'gallery.emptyDesc': 'Stüdyodan ilk kapağını üret, burada görünecek.',
    'gallery.goStudio': 'Stüdyoya Git',
    'gallery.itemFailed': 'Başarısız: {error}',
    'gallery.itemGenerating': 'Üretiliyor...',
    'gallery.noPrompt': 'Prompt yok',
    'gallery.coverAlt': 'Kapak',
    'gallery.previewAlt': 'Kapak büyük önizleme',
    'gallery.deleteConfirmTitle': 'Bu kapak silinsin mi?',

    // ---------- account ----------
    'account.title': 'Hesabım',
    'account.loadFailed': 'Hesap bilgileri yüklenemedi',
    'account.statCredits': 'Kapak Hakkı Bakiyesi',
    'account.statTotal': 'Toplam Üretim',
    'account.statDone': 'Başarılı Kapak',
    'account.statPhotos': 'Fotoğraf',
    'account.creditsTitle': 'Kapak Fotoğrafı Hakkı',
    'account.creditsDesc':
      'Her üretim 1 kapak fotoğrafı hakkı harcar. Başarısız üretimlerde hakkın otomatik iade edilir.',
    'account.buyButton': 'Kapak Fotoğrafı Hakkı Satın Al',
    'account.txTitle': 'Hak Hareketleri',
    'account.photosTitle': 'Fotoğraflarım',
    'account.photosDesc': 'Buraya yüklediğin fotoğraflar Stüdyo 2. adımda seçilebilir hale gelir.',
    'account.uploadTitle': 'Fotoğraf Yükle',
    'account.uploadHint': 'Birden fazla seçebilirsin - PNG, JPG, WEBP',
    'account.photosEmpty': 'Henüz fotoğraf yüklemedin. Fotoğraf Yükle ile başlayalım.',
    'account.photosAdded': 'Fotoğraf(lar) eklendi',
    'account.photoUploadFailed': 'Fotoğraf yüklenemedi',
    'account.photoDeleted': 'Fotoğraf silindi',
    'account.deleteFailed': 'Silinemedi',
    'account.deletePhotoTitle': 'Fotoğraf silinsin mi?',

    // ---------- payments ----------
    'pay.stage1Title': 'Paket Seç',
    'pay.stage2Title': 'Ödemeyi Tamamla',
    'pay.stage3Title': 'Ödemeyi Bildir',
    'pay.stage1Desc': 'Kaç kapak fotoğrafı hakkı yüklemek istediğini seç.',
    'pay.stage2Desc': 'IBAN bilgilerimize havale/EFT yaparak ödemeni tamamla.',
    'pay.stage3Desc': 'Ödemeni yaptıysan bu formu doldur; kontrol edip hakkını yükleyeceğiz.',
    'pay.popular': 'POPÜLER',
    'pay.creditsUnit': 'hak',
    'pay.bankTitle': 'Banka / IBAN ile öde',
    'pay.receiver': 'Alıcı: ',
    'pay.ibanCopied': 'IBAN kopyalandı',
    'pay.noMethodTitle': 'Ödeme yöntemi henüz tanımlanmamış',
    'pay.noMethodDesc':
      'Yönetici IBAN bilgisini eklediğinde burada görünecek. Yine de aşağıdan bildirim gönderebilirsin.',
    'pay.iPaid': 'Ödemeyi Yaptım',
    'pay.senderLabel': 'Ödemeyi yapan kişinin adı *',
    'pay.senderPlaceholder': 'Ad Soyad',
    'pay.senderRequired': 'Ödemeyi yapan kişinin adını yaz',
    'pay.refLabel': 'Referans / işlem no (varsa)',
    'pay.refPlaceholder': 'Örn: sipariş no veya havale açıklaması',
    'pay.noteLabel': 'Not (opsiyonel)',
    'pay.notePlaceholder': 'Eklemek istediğin bir şey var mı?',
    'pay.receiptLabel': 'Dekont / ekran görüntüsü (opsiyonel)',
    'pay.receiptAdded': 'Dekont eklendi - değiştirmek için tıkla',
    'pay.receiptChoose': 'Dosya seç',
    'pay.receiptUploaded': 'Dekont eklendi',
    'pay.receiptFailed': 'Dekont yüklenemedi',
    'pay.submit': 'Bildirimi Gönder',
    'pay.submitted': 'Ödeme bildirimin alındı. Onaydan sonra hakkın yüklenecek.',
    'pay.submitFailed': 'Bildirim gönderilemedi',
    'pay.couponTitle': 'Kapak Hakkı Kodu Kullan',
    'pay.couponDesc': 'Ödeme sonrası verilen kodu buraya girersen hakkın anında yüklenir.',
    'pay.couponEmpty': 'Kapak hakkı kodunu gir',
    'pay.couponUse': 'Kodu Kullan',
    'pay.couponSuccess': '{count} kapak hakkı hesabına eklendi!',
    'pay.couponFailed': 'Kod kullanılamadı',
    'pay.requestsTitle': 'Ödeme Bildirimlerim',
    'pay.statusPending': 'Onay bekliyor',
    'pay.statusApproved': 'Onaylandı',
    'pay.statusRejected': 'Reddedildi',

    // ---------- image drop ----------
    'drop.defaultTitle': 'Görseli sürükle, tıkla veya Ctrl+V ile yapıştır',
    'drop.defaultHint': 'PNG, JPG veya WEBP - en fazla 12MB',
    'drop.uploading': 'Yükleniyor...',
    'drop.aria': 'Dosya yükle',
  },

  en: {
    // ---------- common ----------
    'common.back': 'Back',
    'common.next': 'Continue',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.download': 'Download',
    'common.loading': 'Loading...',
    'common.locale': 'en-US',
    'common.pieces': '{count} item(s)',
    'common.none': 'None',
    'common.seconds': 's',
    'common.copied': 'Copied',
    'common.copyManually': 'Copy manually: {text}',
    'common.irreversible': 'This action cannot be undone.',
    'common.langLabel': 'Language',

    // ---------- nav ----------
    'nav.studio': 'Studio',
    'nav.gallery': 'Gallery',
    'nav.account': 'Account',
    'nav.admin': 'Admin',
    'nav.adminPanel': 'Admin Panel',
    'nav.accountCredits': 'Account & Credits',
    'nav.logout': 'Log Out',
    'nav.creditsShort': 'credits',

    // ---------- landing ----------
    'landing.goStudio': 'Go to Studio',
    'landing.login': 'Log In',
    'landing.tryNow': 'Try It Now!',
    'landing.heroLine1': 'From now on you will get',
    'landing.heroLine2': 'far more views...',
    'landing.heroDesc':
      'Inspired by Pablo Picasso\u2019s famous line about \u201Cgood artists\u201D: just drop a reference and create your cover image with your own photo.',
    'landing.freeBadge': '{count} free cover credits on us',
    'landing.card1Title': 'Horizontal Video',
    'landing.card1Desc': 'Widescreen cover for classic YouTube videos.',
    'landing.card2Title': 'YT Shorts',
    'landing.card2Desc': 'Full-screen cover for vertical Shorts videos.',
    'landing.footer': 'Spunkram Thumbnailer - AI-powered cover image studio',
    'how.eyebrow': 'HOW IT WORKS',
    'how.title': 'From raw shot to clickable cover in three steps',
    'how.subtitle':
      'Drop the cover you like or your own raw photo, then say what should change. '
      + 'We handle the rest - the output arrives at exact size, ready to download.',
    'how.s1Title': 'Give the reference',
    'how.s1Desc':
      'Paste the YouTube link of the cover you like, or just upload the image.',
    'how.s2Title': 'Say what should change',
    'how.s2Desc':
      'Describe the text, background or lighting in one sentence. You can also list what must stay.',
    'how.s3Title': 'Your cover is ready',
    'how.s3Desc':
      'Download it in seconds as 1920x1080 landscape or 1080x1920 vertical JPG, under 2 MB.',
    'how.beforeLabel': 'BEFORE',
    'how.afterLabel': 'AFTER',
    'how.editsLabel': 'YOUR REQUESTS',
    'how.edit1': 'use my face and change the text',
    'how.beforeAlt': 'The cover given as reference',
    'how.afterAlt': 'The cover generated with Spunkram',
    'how.note': 'The example above is a real cover flow produced with Spunkram.',

    // ---------- auth ----------
    'auth.loginTitle': 'Log In',
    'auth.loginSubtitle': 'Pick up right where you left off.',
    'auth.email': 'Email',
    'auth.emailPlaceholder': 'example@mail.com',
    'auth.password': 'Password',
    'auth.passwordPlaceholder': '********',
    'auth.noAccount': "Don't have an account?",
    'auth.registerLink': 'Sign up',
    'auth.welcome': 'Welcome back!',
    'auth.loginFailed': 'Could not log in',
    'auth.registerTitle': 'Sign Up',
    'auth.registerSubtitle': 'Get started - {count} cover images are waiting in your account as a welcome gift.',
    'auth.name': 'Full Name',
    'auth.namePlaceholder': 'Your name',
    'auth.passwordMin': 'At least 6 characters',
    'auth.passwordTooShort': 'Password must be at least 6 characters',
    'auth.createAccount': 'Create Account',
    'auth.registerSuccess': 'Your account is ready - {count} cover images gifted!',
    'auth.registerFailed': 'Could not create account',
    'auth.haveAccount': 'Already have an account?',
    'auth.loginLink': 'Log in',
    'auth.googleContinue': 'Continue with Google',
    'auth.googleSigningIn': 'Signing you in with Google...',
    'auth.googleFailed': 'Could not sign in with Google',
    'auth.or': 'or',

    // ---------- studio ----------
    'studio.title': 'Studio',
    'studio.subtitle': 'Create your cover image in four steps.',
    'studio.selectedFormat': 'Selected format',
    'studio.balance': 'Balance: {count} cover credits',
    'studio.step1Title': 'Format & Reference',
    'studio.step1Hint': 'YouTube / Shorts',
    'studio.step2Title': 'Photo Selection',
    'studio.step2Hint': 'Your own photo',
    'studio.step3Title': 'Text & Request',
    'studio.step3Hint': 'What will change?',
    'studio.step4Title': 'Summary',
    'studio.step4Hint': 'Generate & download',
    'studio.fidelityExact': 'Ultra Faithful',
    'studio.fidelityCreative': 'Creative',
    'studio.fidelityExactDesc': 'Everything stays identical except the parts you ask to change',
    'studio.fidelityCreativeDesc':
      'Refreshes colors and icons, producing a bolder take on the reference logic',
    'studio.coverReady': 'Your cover is ready!',
    'studio.genFailed': 'Generation failed: {error}',
    'studio.unknownError': 'unknown error',
    'studio.statusFetchFailed': 'Could not fetch generation status',
    'studio.needSomething': 'Without a reference image you must add at least a text or a custom request',
    'studio.startFailed': 'Could not start generation',
    'studio.downloadStarted': 'Download started',
    'studio.downloadFailed': 'Could not download the file',

    // summary rows
    'studio.sum.coverType': 'Cover type',
    'studio.sum.output': 'Output',
    'studio.sum.reference': 'Reference',
    'studio.sum.photo': 'Photo',
    'studio.sum.extras': 'Extra images',
    'studio.sum.texts': 'Texts',
    'studio.sum.fidelity': 'Fidelity',
    'studio.sum.cost': 'Cost',
    'studio.sum.costValue': '1 cover image credit',
    'studio.sum.ytShorts': 'YT Shorts (9:16)',
    'studio.sum.youtube': 'YouTube (16:9)',
    'studio.sum.refYoutube': 'YouTube cover',
    'studio.sum.refUpload': 'Uploaded image',
    'studio.sum.photoSelected': 'Selected',
    'studio.sum.photoUnused': 'Not used',
    'studio.sum.textsUnchanged': 'Unchanged',

    // step 1
    'step1.coverQuestion': 'What kind of cover?',
    'step1.coverDesc':
      'This sets the output format. Even with a horizontal reference, choosing Shorts re-composes it for vertical.',
    'step1.youtubeHint': '16:9 horizontal - 1920x1080',
    'step1.shortsHint': '9:16 vertical - 1080x1920',
    'step1.refTitle': 'Reference Image',
    'step1.refDesc':
      'Give us the cover to take inspiration from. Upload/paste an image or pull it from a YouTube link.',
    'step1.refUploaded': 'Reference image uploaded.',
    'step1.refUploadedToast': 'Reference image uploaded',
    'step1.uploadFailed': 'Could not upload the image',
    'step1.pasteFirst': 'Paste a YouTube link first',
    'step1.fetched': 'Cover image fetched',
    'step1.fetchFailed': 'Could not fetch the cover image',
    'step1.orYoutube': 'OR YOUTUBE LINK',
    'step1.fetchCover': 'Fetch Cover',
    'step1.youtubeNote':
      'Only horizontal YouTube video links are supported. A Shorts link will show a warning - for a vertical cover pick \u201CYT Shorts\u201D above and give a horizontal cover as reference.',
    'step1.dropTitle': 'Drag, click or paste (Ctrl+V) the reference image',
    'step1.sourceYoutube': 'YouTube',
    'step1.sourceUpload': 'Uploaded image',

    // step 2
    'step2.title': 'Photo Selection',
    'step2.desc': 'If you want your own photo on the cover, turn on the option below and pick a photo.',
    'step2.switchLabel': 'Do you want to use a photo?',
    'step2.emptyTitle': "You haven't uploaded a photo yet",
    'step2.emptyDesc1': 'You can upload right here or use',
    'step2.emptyLink': 'Account > My Photos',
    'step2.emptyDesc2': 'section.',
    'step2.uploadTitle': 'Upload a new photo',
    'step2.uploadHint': 'Uploaded photos are stored in your Account section',
    'step2.skip': "You won't use a photo - feel free to skip this step.",
    'step2.photosAdded': 'Photo(s) added',
    'step2.photoUploadFailed': 'Could not upload the photo',

    // step 3
    'step3.textsTitle': 'Texts',
    'step3.textsDesc':
      'If you type only a word, that word replaces the reference text in the exact same style. You can also write an instruction like \u201Creplace insane with amazing\u201D.',
    'step3.textsPlaceholder': 'e.g. AMAZING   or:  replace insane with amazing',
    'step3.promptTitle': 'Custom Request',
    'step3.promptDesc':
      'What else should change or stay the same? Position extra images with @1, @2.',
    'step3.promptPlaceholder':
      'e.g. Make the background red-black, sharpen the face, keep the pose. Put image @1 on the right.',
    'step3.sug1': 'Make the background red-black, boost contrast',
    'step3.sug2': 'Make the facial expression more shocked',
    'step3.sug3': 'Add more cinematic light and shadow',
    'step3.sug4': 'Keep the face and pose exactly the same',
    'step3.extrasTitle': 'Extra Images',
    'step3.extrasMax': 'You can add up to 4 extra images',
    'step3.extrasAdded': '{count} extra image(s) added',
    'step3.extrasFailed': 'Could not upload the extra image',
    'step3.extrasDropTitle': 'Add extra image (@1, @2 ...)',
    'step3.extrasDropHint': 'Product, logo, person or object images - up to 4',
    'step3.addToPrompt': 'Add to custom request',
    'step3.fidelityTitle': 'Reference Fidelity',
    'step3.tip':
      'Tip: also write what must NOT change. Example: \u201CKeep the face and pose the same, only change the background.\u201D',

    // step 4
    'step4.title': 'Summary & Confirm',
    'step4.desc':
      'Output is delivered as a {size} pixel JPG under 2 MB. This generation spends 1 cover image credit.',
    'step4.summaryTitle': 'Generation Summary',
    'step4.noCreditsTitle': 'You have no cover image credits left',
    'step4.noCreditsLink': 'Buy Cover Image Credits',
    'step4.noCreditsDesc': 'section lets you top up.',
    'step4.generating': 'Generating...',
    'step4.generate': 'Generate Cover',

    // preview panel
    'preview.title': 'Preview',
    'preview.status1': 'Analyzing the reference...',
    'preview.status2': 'Preparing the composition...',
    'preview.status3': 'Processing details...',
    'preview.status4': 'Tuning color and contrast...',
    'preview.status5': 'Final retouches...',
    'preview.resultAlt': 'Generated cover',
    'preview.failedTitle': 'Generation failed',
    'preview.refunded': 'Your cover credit has been refunded.',
    'preview.refAlt': 'Reference preview',
    'preview.emptyHint': 'The preview appears here as soon as you add a reference',
    'preview.dontClose': "Generation in progress - don't close the tab.",
    'preview.downloadPng': 'Download PNG',
    'preview.variation': 'Variation',
    'preview.newCover': 'New Cover',

    // ---------- gallery ----------
    'gallery.title': 'Gallery',
    'gallery.subtitle': 'All the covers you created live here.',
    'gallery.filterAll': 'All',
    'gallery.loadFailed': 'Could not load the gallery',
    'gallery.deleted': 'Deleted',
    'gallery.deleteFailed': 'Could not delete',
    'gallery.downloadFailed': 'Could not download',
    'gallery.emptyTitle': 'No generations yet',
    'gallery.emptyDesc': 'Create your first cover in the Studio and it will show up here.',
    'gallery.goStudio': 'Go to Studio',
    'gallery.itemFailed': 'Failed: {error}',
    'gallery.itemGenerating': 'Generating...',
    'gallery.noPrompt': 'No prompt',
    'gallery.coverAlt': 'Cover',
    'gallery.previewAlt': 'Large cover preview',
    'gallery.deleteConfirmTitle': 'Delete this cover?',

    // ---------- account ----------
    'account.title': 'My Account',
    'account.loadFailed': 'Could not load account details',
    'account.statCredits': 'Cover Credit Balance',
    'account.statTotal': 'Total Generations',
    'account.statDone': 'Successful Covers',
    'account.statPhotos': 'Photos',
    'account.creditsTitle': 'Cover Image Credits',
    'account.creditsDesc':
      'Each generation spends 1 cover image credit. Failed generations are refunded automatically.',
    'account.buyButton': 'Buy Cover Image Credits',
    'account.txTitle': 'Credit History',
    'account.photosTitle': 'My Photos',
    'account.photosDesc': 'Photos uploaded here become selectable in Studio step 2.',
    'account.uploadTitle': 'Upload Photo',
    'account.uploadHint': 'You can pick multiple - PNG, JPG, WEBP',
    'account.photosEmpty': "You haven't uploaded any photos yet. Start with Upload Photo.",
    'account.photosAdded': 'Photo(s) added',
    'account.photoUploadFailed': 'Could not upload the photo',
    'account.photoDeleted': 'Photo deleted',
    'account.deleteFailed': 'Could not delete',
    'account.deletePhotoTitle': 'Delete this photo?',

    // ---------- payments ----------
    'pay.stage1Title': 'Choose Package',
    'pay.stage2Title': 'Complete Payment',
    'pay.stage3Title': 'Report Payment',
    'pay.stage1Desc': 'Pick how many cover image credits you want to load.',
    'pay.stage2Desc': 'Complete your payment with a bank transfer to our IBAN.',
    'pay.stage3Desc': "If you've paid, fill in this form; we'll verify and load your credits.",
    'pay.popular': 'POPULAR',
    'pay.creditsUnit': 'credits',
    'pay.bankTitle': 'Pay via Bank / IBAN',
    'pay.receiver': 'Recipient: ',
    'pay.ibanCopied': 'IBAN copied',
    'pay.noMethodTitle': 'No payment method defined yet',
    'pay.noMethodDesc':
      'It will appear here once the admin adds IBAN details. You can still send a report below.',
    'pay.iPaid': 'I Have Paid',
    'pay.senderLabel': "Payer's full name *",
    'pay.senderPlaceholder': 'Full Name',
    'pay.senderRequired': "Please write the payer's name",
    'pay.refLabel': 'Reference / transaction no (if any)',
    'pay.refPlaceholder': 'e.g. order no or transfer description',
    'pay.noteLabel': 'Note (optional)',
    'pay.notePlaceholder': 'Anything you want to add?',
    'pay.receiptLabel': 'Receipt / screenshot (optional)',
    'pay.receiptAdded': 'Receipt added - click to replace',
    'pay.receiptChoose': 'Choose file',
    'pay.receiptUploaded': 'Receipt added',
    'pay.receiptFailed': 'Could not upload the receipt',
    'pay.submit': 'Send Report',
    'pay.submitted': 'We received your payment report. Credits will be loaded after approval.',
    'pay.submitFailed': 'Could not send the report',
    'pay.couponTitle': 'Redeem Cover Credit Code',
    'pay.couponDesc': 'Enter the code given after payment and your credits load instantly.',
    'pay.couponEmpty': 'Enter your cover credit code',
    'pay.couponUse': 'Redeem Code',
    'pay.couponSuccess': '{count} cover credits added to your account!',
    'pay.couponFailed': 'Could not redeem the code',
    'pay.requestsTitle': 'My Payment Reports',
    'pay.statusPending': 'Awaiting approval',
    'pay.statusApproved': 'Approved',
    'pay.statusRejected': 'Rejected',

    // ---------- image drop ----------
    'drop.defaultTitle': 'Drag, click or paste (Ctrl+V) an image',
    'drop.defaultHint': 'PNG, JPG or WEBP - max 12MB',
    'drop.uploading': 'Uploading...',
    'drop.aria': 'Upload file',
  },
};
